import { User } from 'src/app/shared/models/user.model';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject} from 'rxjs';
import { map, takeUntil} from 'rxjs/operators';
import { FolderStructure,  SupplierDetails, SolarForms, UploadFile, DocumentsTypeByPath,DocumentsDetailsRawData, DocumentsDetails, GetDocumentTypesRequest,GetMaterialMetaData, IsFileExists, FileUploadPathByDocumentType, GetFilePathByDocumentType} from '../shared/models/documents.model';
import { DataSourceService } from './data-source.service';
import { FILE_EXTENSION_TYPE, FILE_BLOB_TYPE, AppConstants } from 'src/app/app.constants';
import * as FileSaver from 'file-saver';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})

export class DocumentsRepositoryService  {
  breadCrumb: ReplaySubject<string[]> = new ReplaySubject<string[]>(3);
  breadCrumb$: Observable<string[]> = this.breadCrumb.asObservable();
  saveGridOption=[] 
  saveRowData=[];
  //savefilterBy:any 
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(private dataSource: DataSourceService) { }

  getDocumentsFolder(supplierId:string): Observable<FolderStructure> {
    return this.dataSource.getDocumentsFolder(supplierId);
  }

  getSupplierDetailsById(id: string): Observable<SupplierDetails> {
    return this.dataSource.getSupplierDetailsById(id);
  }
  getAllSuppliers(): Observable<SupplierDetails[]> {
    return this.dataSource.getAllSuppliers();
  }
  getSolarForms(): Observable<SolarForms[]> {
    return this.dataSource.getSolarForms();
  }

  getSolarFormDownload(id: string): Observable<Blob> {
    return this.dataSource.getSolarFormFileById(id);
  }

  getDownloadAccountRequestForm(id: string): Observable<Blob> {
    return this.dataSource.getDownloadAccountFormById(id);
  }

  uploadSolarForm(data:FormData): Observable<any> {
    return this.dataSource.uploadSolarForm(data);
  }
  editUploadSolarForm(data:FormData, fileId:string): Observable<any> {
    return this.dataSource.editUploadSolarForm(data, fileId);
  }
  softDeleteSolarForm(fileId: string): Observable<any> {
    return this.dataSource.softDeleteSolarForm(fileId);
  }
  getUndoSolarFormRecord(fileId: string): Observable<any> {
    return this.dataSource.getUndoSolarFormRecord(fileId);
  }
  getValidFileExtensions(): Observable<string[]> {
    return this.dataSource.getValidFileExtensions();
  }

  getUploadedFilesByPath(filePathData: GetDocumentTypesRequest):Observable<DocumentsDetailsRawData[]>{
    return this.dataSource.getUploadedFilesByPath(filePathData)   
  }
  
  getDocumentTypesByPath(filePathData: GetDocumentTypesRequest): Observable<DocumentsTypeByPath> { 
    return this.dataSource.getDocumentTypesByPath(filePathData);
  }

  getMaterialMetaData(): Observable<GetMaterialMetaData[]> { 
    return this.dataSource.getMaterialMetaData();
  }  
  
  getUploadedFilesById(fileId: string): Observable<DocumentsDetailsRawData> { 
    return this.dataSource.getUploadedFilesById(fileId);
  }
  
  getFileDownloadById(id: string): Observable<Blob> {
    return this.dataSource.getFileDownloadById(id);
  }

  previewFileById(id: string): Observable<Blob> {
    return this.dataSource.previewFileById(id);
  }

  getFilePreviewById(id: string): Observable<any> {
    return this.dataSource.getFilePreviewById(id);
  }

  isDocumentExit(fileName:string, supplierId:string ): Observable<Boolean> {
    return this.dataSource.isDocumentExit(fileName, supplierId);
  }
  getUploadPathByDocumentType(data:GetFilePathByDocumentType ): Observable<any> {
    return this.dataSource.getUploadPathByDocumentType(data);
  }
  folderPermission(folderName:string, loggedUserDetails:User, readWriteCheck?:boolean):boolean{
    const folderPermissions:any=loggedUserDetails.folderPermissions; //due to typescript error.
    for(let index=0; index<folderPermissions.folderPermissions.length;index+=1){
     for(let subIndex=0; subIndex<folderPermissions.folderPermissions[index].folders.length;subIndex+=1){
        if(folderPermissions.folderPermissions[index].folders[subIndex].folderName===folderName && readWriteCheck){
          return  folderPermissions.folderPermissions[index].folderAccessDescription===AppConstants.ReadWrite?true:false
          break
        } else if(folderPermissions.folderPermissions[index].folders[subIndex].folderName===folderName){
          return  true
          break
        }  
     }
    } 
  }
  documentSearch(fromDate, toDate , role: string, supplierId: string) {
  
    if(!supplierId){
      supplierId='';
      role=''
    } 
    const params = new HttpParams()
      .set('fromDateString', fromDate.toString().split('G')[0])
      .set('toDateString', toDate.toString().split('G')[0])      
      .set('role', role)
      .set('supplierId', supplierId)
    return this.dataSource.documentSearch(params);
  }

  

}
 

